import {ActivityIndicator, Image, Keyboard, SafeAreaView, Text, TouchableOpacity, View} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome5";
import {TextInput, Button, Snackbar} from 'react-native-paper';
import {useState} from "react";
import axios from "axios";
import LoginMessages from "./LoginMessages";
import {useDispatch} from "react-redux";
import Constants from 'expo-constants';


const baseUrl = (Constants.experienceUrl == 'http://localhost:19006') ? 'https://shop2support.test' : Constants.experienceUrl;

export default function SignIn({navigation,route}){
    let params = route.params
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [isLoading,setIsLoading] = useState(false)
    const [hasError, setErrorFlag] = useState(false)
    const [snackbarVisible, setSnackbarVisible] = useState(true);
    const [errorMessage, setErrorMessage] = useState('')
    function hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    function shadeRGB(rgb, shade){
        return "rgba("+rgb['r']+","+rgb['g']+","+rgb['b']+"," + shade +")"
    }

    const postUrl = `${baseUrl}/wp-json/custom/v1/user_login`;
    const login = async () => {
        try {
            setIsLoading(true)
            setErrorFlag(false)
            return await axios.post(postUrl,{
                'user': encodeURIComponent(username),
                'password': password
            });
        } catch (error) {
            if(axios.isCancel(error)){
                console.log('Data fetching cancelled');
            }else{
                if(error.response.status === 403){
                    return error.response
                }
                console.log(error)
                setErrorFlag(true);
                setIsLoading(false);
            }
        }
    }

    function attemptLogin() {
        Keyboard.dismiss()
        setIsLoading(true)
        login().then( response => {
            if (response.status === 200) {
                setIsLoading(false)
                dispatch({
                    type:'USER_LOGIN',
                    payload:response.data.user
                })
                navigation.navigate(params.previousScreen)
            } else if(response.status === 403) {
                setIsLoading(false)
                setErrorMessage('Invalid login')
                setErrorFlag(true)
            } else {
                throw new Error("Failed to fetch offers");
            }
        })
    }

    const onChangeUsername = value => {
        //const error = validate(value, {empty: false});
        setUsername(value);
        //setErrorUsername(error);
    };

    const onChangePassword = value => {
        //const error = validate(value, {empty: false});
        setPassword(value);
        //setErrorUsername(error);
    };

    const dispatch = useDispatch()

    const rgbColour = hexToRgb(params.appData.theme_colour)

    const onDismissSnackBar = () => setSnackbarVisible(false);

    return(
        <View style={{flex:1}}>
            <Snackbar
                visible={snackbarVisible}
                onIconPress={onDismissSnackBar}
                onDismiss={onDismissSnackBar}
                duration={Infinity}
                action={{
                    label: 'Close',
                    onPress: () => {
                        // Do something
                    },
                }}>
                <TouchableOpacity
                    onPress={() => navigation.navigate('SignUp',{...params,merge:true})}>
                    <View style={{flexDirection:'row'}}>
                        <Text style={{fontSize: 14}}>Not a member yet? </Text>
                        <Text style={{textDecorationLine: 'underline'}}>Click here to login</Text>
                    </View>
                </TouchableOpacity>
            </Snackbar>
            <TouchableOpacity
                onPress={() => navigation.navigate('Home')}>
                <View style={{marginHorizontal:20, marginVertical:50,flexDirection:"row"}}>
                    <Icon
                        name="arrow-left"
                        color='#ddddd'
                        size={20}
                    />
                    <Text style={{marginLeft:15}}>Back</Text>
                </View>
            </TouchableOpacity>
            <SafeAreaView edges={['right', 'left']} style={{marginHorizontal:20}}>
                <TextInput
                    value={username}
                    style={{marginBottom:15,backgroundColor: shadeRGB(rgbColour,0.2)}}
                    placeholder="Email"
                    mode="flat"
                    onChangeText={onChangeUsername}
                />
                <TextInput
                    value={password}
                    style={{backgroundColor:shadeRGB(rgbColour,0.2)}}
                    placeholder="Password"
                    mode="flat"
                    onChangeText={onChangePassword}
                    secureTextEntry={true}
                />
                { !isLoading ?
                    <Button
                        onPress={attemptLogin}
                        title={'Sign In'}
                        style={{marginTop: 20,backgroundColor:shadeRGB(rgbColour,1)}}
                        icon="login" mode="contained"
                    >
                        Sign In
                    </Button>
                    :
                    <ActivityIndicator
                        style={{marginTop:10}}
                        size="small"
                        color={params.appData.theme_colour}
                    />
                }
                <LoginMessages hasError={hasError} message={errorMessage} />
                <TouchableOpacity
                    onPress={() => navigation.navigate('ResetPassword',{...params,merge:true})}>
                    <View style={{marginHorizontal:20, marginVertical:50}}>
                        <Text style={{fontSize:14}}>Forgotten your password?</Text>
                        <Text style={{color:'blue',textDecorationLine:'underline'}}>Reset password</Text>
                    </View>
                </TouchableOpacity>
            </SafeAreaView>
        </View>
    )
}